import React from "react";
import { styled } from "@mui/material/styles";
import { Box, BoxProps, InternalStandardProps } from "@mui/material";
import { AppTypography } from "JS/React/Components/AppTypography";
import { AppButton } from "JS/React/Components/AppButton";

export interface QuizFooterProps extends InternalStandardProps<BoxProps> {
    title?: string;
    subTitle?: string;
    btnText?: string;
    disableBtn?: boolean;
    onBtnClick?: () => void;
    increaseHeight?: boolean;
}

interface StyledRootProps {
    increaseHeight?: boolean;
}

const StyledRoot = styled(Box, {
    shouldForwardProp: (prop) => prop !== "increaseHeight",
})<StyledRootProps>(({ theme, increaseHeight }) => ({
    background:
        theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[900],
    padding: theme.spacing(2, 4),
    minHeight: increaseHeight ? "250px" : "150px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
}));

const StyledBtn = styled(AppButton)(({ theme }) => ({
    background:
        theme.palette.mode === "light"
            ? theme.colors.white
            : theme.palette.grey[900],
    color: theme.palette.grey[600],
}));

const StyledSubTitle = styled(AppTypography)(({ theme }) => ({
    margin: theme.spacing(2, 0),
}));

const StyledSubTitleClamp = styled(StyledSubTitle)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

export const QuizFooter = (props: QuizFooterProps) => {
    const {
        className,
        title,
        subTitle,
        btnText,
        disableBtn,
        onBtnClick = () => {},
        increaseHeight,
        ...rest
    } = props;

    const SubTitleComponent = increaseHeight ? StyledSubTitleClamp : StyledSubTitle;

    return (
        <StyledRoot {...rest} className={className} increaseHeight={increaseHeight}>
            {title && (
                <AppTypography
                    fontWeight={"bold"}
                    variant="h5"
                    textColor="grey-a100"
                >
                    {title}
                </AppTypography>
            )}

            {subTitle && (
                <SubTitleComponent
                    variant="h6"
                    textColor="grey-a100"
                >
                    {subTitle}
                </SubTitleComponent>
            )}

            {btnText && (
                <Box textAlign="center">
                    <StyledBtn
                        disabled={disableBtn}
                        onClick={onBtnClick}
                        buttonVariant="grey-outlined"
                        rounded
                    >
                        {btnText}
                    </StyledBtn>
                </Box>
            )}
        </StyledRoot>
    );
};
